import { Injectable } from '@angular/core';
import { CommonApiService } from '@core/api/common.api.service';
import { Role } from '@core/models/Role';
import { EnvVarsService } from '@root/app/env-vars.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RoleApiService {
  private API_URL = this.environment.getEnvKey('API_URL');
  private namespace = 'roles';
  private url = `${this.API_URL}/${this.namespace}`;
  constructor(
    private common: CommonApiService,
    private environment: EnvVarsService
  ) {}

  public getRoles() {
    return this.common.get<Role[]>(`${this.url}`).toPromise();
  }
}
